import { render, staticRenderFns } from "./outBoxList,.vue?vue&type=template&id=1685b037&"
import script from "./outBoxList,.vue?vue&type=script&lang=js&"
export * from "./outBoxList,.vue?vue&type=script&lang=js&"
import style0 from "./outBoxList,.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports